<svelte:options customElement={{
  tag: 'text-link',
  shadow: 'none',
  props: {
    href: { reflect: true, type: 'String' },
    label: { reflect: true, type: 'String' },
    variant: { reflect: true, type: 'String' },
    icon: { reflect: true, type: 'String' },
    iconposition: { reflect: true, type: 'String' },
    color: { reflect: true, type: 'String' },
    weight: { reflect: true, type: 'String' },
    target: { reflect: true, type: 'String' },
    filesize: { reflect: true, type: 'String' },
    filetype: { reflect: true, type: 'String' }
  }
}} />

<script>
  import SvgIcon from './SvgIcon.svelte';

  /**
   * textlink：テキストリンク
   * パーツライブラリ準拠の mod-link01 / mod-link02 構造
   * @prop {string} href - リンク先URL
   * @prop {string} label - リンクテキスト
   * @prop {string} variant - 'standalone' (mod-link01) | 'inline' (mod-link02)
   * @prop {string} icon - アイコン名（SvgIcon の name に準拠）:
   *   'arrow_right' (右矢印), 'blank' (新しいウィンドウ), 'pdf', 'download',
   *   'arrow_left' (左矢印), 'none' (アイコンなし)
   * @prop {string} iconposition - アイコン位置: 'left' | 'right' | '' (自動判定)
   * @prop {string} color - テキストカラー: 'default' (黒) | 'link' (赤リンク色)
   * @prop {string} weight - フォントウェイト: 'regular' | 'bold'
   * @prop {string} target - target属性 ('_blank' 等)
   */
  export let href = '#';
  export let label = '';
  export let variant = 'standalone';
  export let icon = 'arrow_right';
  export let iconposition = '';
  export let color = 'default';
  export let weight = 'regular';
  export let target = '';
  export let filesize = '';
  export let filetype = '';

  $: hasIcon = icon && icon !== 'none';

  // iconposition未指定時は自動判定（左矢印系は左、それ以外は右）
  $: resolvedPosition = iconposition || (
    (icon === 'arrow_left' || icon === 'arrow_left_double') ? 'left' : 'right'
  );

  $: linkClass = [
    variant === 'inline' ? 'mod-link02' : 'mod-link01',
    color === 'link' ? '_link' : '',
    weight === 'bold' ? '_bold' : '',
    icon === 'blank' ? '__blank' : '',
    icon === 'pdf' ? '__pdf' : ''
  ].filter(Boolean).join(' ');
</script>

<a {href} class={linkClass} target={target || null} rel={target === '_blank' ? 'noopener noreferrer' : null}>
  {#if hasIcon && resolvedPosition === 'left'}
    <SvgIcon name={icon} size="lg" />
  {/if}
  {#if variant === 'standalone'}
    <span class="_text">{label}</span>
  {:else}
    {label}
  {/if}
  {#if hasIcon && resolvedPosition === 'right'}
    <SvgIcon name={icon} size="lg" />
  {/if}
  {#if filesize}
    <span class="_fileSize">(
      {#if filetype}
        {filetype}:
      {/if}
      {filesize}
      )</span>
  {/if}
</a>
